import React, { createContext, useContext } from 'react';

export interface ShellBootstrapContextValue {
  /** False while the host PKS catalog sync is still in flight. */
  catalogReady: boolean;
}

const ShellBootstrapContext = createContext<ShellBootstrapContextValue>({
  catalogReady: true,
});

export function ShellBootstrapProvider({
  catalogReady,
  children,
}: ShellBootstrapContextValue & { children: React.ReactNode }): React.ReactElement {
  return (
    <ShellBootstrapContext.Provider value={{ catalogReady }}>
      {children}
    </ShellBootstrapContext.Provider>
  );
}

export function useShellBootstrap(): ShellBootstrapContextValue {
  return useContext(ShellBootstrapContext);
}
